// extracted by mini-css-extract-plugin
export var header = "_sk-1";
export var maskBottom = "_sk-6";
export var maskMiddle = "_sk-7";
export var maskTop = "_sk-5";
export var root = "_sk-0";
export var scrollDownButton = "_sk-3";
export var scrollDownButtonHidden = "_sk-4";
export var viewport = "_sk-2";